import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: 'linear-gradient(180deg, #f1f4ff 0%, #ffffff 70%)',
  border: '2px solid',
  borderColor: 'primary.main',
  borderRadius: 0.5,
  p: 1.5,
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  width: 325,
  flexShrink: 0,
  boxShadow: '0 0 0 4px rgba(24, 81, 239, 0.10)',
};

export const priceRow: SxStyle = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 0.5,
};

export const ratePill: SxStyle = {
  alignSelf: 'flex-start',
  display: 'inline-flex',
  alignItems: 'center',
};

export const statsList: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const statRow: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: 0.75,
};

export const talkToSalesSlot: SxStyle = {
  mt: 'auto',
};
